import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import '../../../../node_modules/lit-media-query/lit-media-query.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import Swiper from '../../../../node_modules/swiper/core/core.js';
import '../../../../node_modules/swiper/shared/dom.js';
import Navigation from '../../../../node_modules/swiper/modules/navigation/navigation.js';
import Pagination from '../../../../node_modules/swiper/modules/pagination/pagination.js';
import Autoplay from '../../../../node_modules/swiper/modules/autoplay/autoplay.js';
import EffectFade from '../../../../node_modules/swiper/modules/effect-fade/effect-fade.js';
import { BaseWithUtils } from '../../lit-mixins/base-with-utils/index.js';
import { renderCustomSwiperNav, onSlideChange } from '../../molecules/carousel-navigation/index.js';
import '../../atoms/buttons/enums.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import css_248z from './image-text-carousel.scss.js';
import css_248z$2 from '../../../styles/global/rich-text.scss.js';
import css_248z$1 from '../../atoms/buttons/generic-button/styles/generic-button.scss.js';

const LitElementWithUtils = BaseWithUtils(s);
const textBlockSelector = 'text-block';
class ImageTextCarousel extends LitElementWithUtils {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.navTemplate = '#number1# of #number2#';
        this.nextText = '';
        this.previousText = '';
    }
    adjustSlots() {
        const slidesWrapper = this.shadowRoot.querySelector('.swiper-wrapper');
        const slotsContainer = this.shadowRoot.querySelector('slot[name="slides-container"]');
        for (const slot of slotsContainer.assignedElements()) {
            slidesWrapper.append(slot);
            const headline = slot.querySelector('.slide-header');
            const textBlock = slot.querySelector(textBlockSelector);
            const primaryCta = slot.querySelector('[slot="primary-cta"]');
            const secondaryCta = slot.querySelector('[slot="secondary-cta"]');
            const richText = textBlock === null || textBlock === void 0 ? void 0 : textBlock.querySelector('.rich-text');
            richText === null || richText === void 0 ? void 0 : richText.prepend(headline);
            if (primaryCta)
                richText === null || richText === void 0 ? void 0 : richText.append(primaryCta);
            if (secondaryCta)
                richText === null || richText === void 0 ? void 0 : richText.append(secondaryCta);
        }
    }
    adjustTabIndexes() {
        setTimeout(() => {
            const slides = this.shadowRoot.querySelectorAll('.swiper-slide');
            const activeSlide = this.shadowRoot.querySelector('.swiper-slide-active');
            for (const slide of slides) {
                const textBlock = slide.querySelector(textBlockSelector);
                const buttons = textBlock.querySelectorAll('.primary-button');
                for (const btn of buttons) {
                    btn.setAttribute('tabindex', '-1');
                }
            }
            const activeTextBlock = activeSlide.querySelector(textBlockSelector);
            const activeButtons = activeTextBlock.querySelectorAll('.primary-button');
            for (const btn of activeButtons) {
                btn.removeAttribute('tabindex');
            }
        }, 0);
    }
    updated() {
        setTimeout(() => {
            var _a, _b, _c, _d, _e, _f;
            const swiperContainer = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.swiper');
            const nav = (_b = this.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('carousel-navigation');
            this._prevBtn = (_c = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.swiper-button-prev');
            this._nextBtn = (_d = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _d === void 0 ? void 0 : _d.querySelector('.swiper-button-next');
            const counter = (_e = nav === null || nav === void 0 ? void 0 : nav.shadowRoot) === null || _e === void 0 ? void 0 : _e.querySelector('.swiper-counter');
            if (swiperContainer) {
                this.adjustSlots();
                this._swiper = new Swiper(swiperContainer, {
                    modules: [Navigation, Pagination, EffectFade, Autoplay],
                    speed: 500,
                    effect: 'fade',
                    fadeEffect: { crossFade: true },
                    pagination: {
                        el: counter,
                        type: 'custom',
                        renderCustom: (swiper, current, total) => renderCustomSwiperNav(this.navTemplate, current, total),
                    },
                    navigation: {
                        nextEl: this._nextBtn,
                        prevEl: this._prevBtn,
                        disabledClass: 'disabled',
                    },
                    preloadImages: false,
                    lazy: true,
                    slidesPerView: 1,
                    spaceBetween: 24,
                    autoplay: ((_f = this.autoScroll) === null || _f === void 0 ? void 0 : _f.toLowerCase()) === 'true'
                        ? {
                            delay: 8000,
                            disableOnInteraction: false,
                        }
                        : false,
                });
                this._swiper.on('slideChange', () => {
                    onSlideChange(this._prevBtn, this._nextBtn);
                    this.adjustTabIndexes();
                });
                onSlideChange(this._prevBtn, this._nextBtn);
                this.adjustTabIndexes();
            }
        }, 0);
    }
    render() {
        var _a;
        return $ `<div class="image-text-carousel ${this.rtl || isRTL() ? 'rtl' : ''} ${(_a = this.utilityClasses) !== null && _a !== void 0 ? _a : ''}"><slot name="headline"></slot><slot name="primary-cta"></slot><slot name="secondary-cta"></slot><div class="swiper"><div class="swiper-wrapper"></div><slot name="slide-header"></slot><slot name="slides-container"></slot></div><carousel-navigation ?rtl="${this.rtl || isRTL() ? 'rtl' : ''}" nextText="${this.nextText}" previousText="${this.previousText}"></carousel-navigation></div>`;
    }
}
ImageTextCarousel.styles = [
    LitElementWithUtils.styles || [],
    css_248z,
    css_248z$1,
    css_248z$2,
];
__decorate([
    e({ type: Boolean })
], ImageTextCarousel.prototype, "rtl", void 0);
__decorate([
    e({ type: String })
], ImageTextCarousel.prototype, "navTemplate", void 0);
__decorate([
    e({ type: String })
], ImageTextCarousel.prototype, "nextText", void 0);
__decorate([
    e({ type: String })
], ImageTextCarousel.prototype, "previousText", void 0);
__decorate([
    e({ type: String })
], ImageTextCarousel.prototype, "autoScroll", void 0);
customElements.define('image-text-carousel', ImageTextCarousel);

export { ImageTextCarousel };
